/**
 * Whether this browser has been signed in before, so a 401 can say "your session has expired"
 * only to people who actually had a session, not to first-time visitors following a link.
 * Holds no account data: just a flag, set on a successful sign-in and cleared on sign-out.
 */

const KEY = 'gdcHadSession';

export const markSignedIn = (): void => {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // Storage blocked: everyone gets the plain sign-in page
  }
};

export const clearSignedIn = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear
  }
};

export const hadSession = (): boolean => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};
